import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _excluded = ["eventType", "label", "value", "nonInteraction"],
  _excluded2 = ["category", "action"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable no-console */
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import ReactGUA from 'react-ga';
import ReactGA4 from 'react-ga4';
import { AnalyticsAction, FISHERMAN_BOT_EVENT, FISHERMAN_EVENT, GOOGLE_ANALYTICS_4_NAME, GOOGLE_UNIVERSAL_ANALYTICS_NAME } from './google-analytics.constants';
var providerName = process.env.ANALYTICS_PROVIDER_NAME;
var analyticsTrackingId = process.env.ANALYTICS_TRACKING_ID;
var GoogleAnalytics = /*#__PURE__*/function () {
  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);
  }
  _createClass(GoogleAnalytics, null, [{
    key: "printToConsole",
    value: function printToConsole() {
      return process.env.FAST_ENV === 'development';
    }
  }, {
    key: "initialize",
    value: function initialize(trackingId) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$testMode = _ref.testMode,
        testMode = _ref$testMode === void 0 ? false : _ref$testMode,
        _ref$debug = _ref.debug,
        debug = _ref$debug === void 0 ? true : _ref$debug;
      if (_isEmpty(providerName) || _isEmpty(trackingId)) {
        console.warn('Analytics Provider or tracking ID is not set');
        return;
      }
      if (providerName === GOOGLE_UNIVERSAL_ANALYTICS_NAME) {
        ReactGUA.initialize(trackingId, {
          testMode: testMode,
          debug: debug,
          gaOptions: {
            cookieDomain: 'auto'
          }
        });
      }
      if (GoogleAnalytics.isGa4Configured()) {
        ReactGA4.initialize(trackingId, {
          testMode: testMode
        });
      }
    }
  }, {
    key: "isGa4Configured",
    value: function isGa4Configured() {
      return providerName.includes(GOOGLE_ANALYTICS_4_NAME);
    }
  }, {
    key: "event",
    value: function event(name, action) {
      var eventData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _eventData$eventType = eventData.eventType,
        eventType = _eventData$eventType === void 0 ? FISHERMAN_EVENT : _eventData$eventType,
        _eventData$label = eventData.label,
        label = _eventData$label === void 0 ? '' : _eventData$label,
        value = eventData.value,
        nonInteraction = eventData.nonInteraction,
        extraEventData = _objectWithoutProperties(eventData, _excluded);
      if (GoogleAnalytics.printToConsole()) {
        console.log('GoogleAnalytics.event', name, action, JSON.stringify(eventData));
      }
      if (_isEmpty(providerName)) {
        console.warn('Analytics provider is not set');
        return;
      }
      var options = {
        category: name,
        action: action
      };
      if (!_isEmpty(label)) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          label: label
        });
      }
      if (!_isNil(value)) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          value: value
        });
      }
      if (!_isNil(nonInteraction)) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          nonInteraction: nonInteraction
        });
      }
      if (providerName === GOOGLE_UNIVERSAL_ANALYTICS_NAME) {
        ReactGUA.event(options);
      }
      if (GoogleAnalytics.isGa4Configured()) {
        if (eventType === FISHERMAN_BOT_EVENT) {
          options = _objectSpread(_objectSpread(_objectSpread({}, options), extraEventData), {}, {
            send_to: analyticsTrackingId
          });
        }
        ReactGA4.gtag('event', eventType, options);
      }
    }
  }, {
    key: "triggerEvent",
    value: function triggerEvent(event) {
      if (!_isEmpty(event)) {
        var category = event.category,
          action = event.action,
          extraEventProps = _objectWithoutProperties(event, _excluded2);
        GoogleAnalytics.event(category, action, extraEventProps);
      }
    }
  }, {
    key: "outbound",
    value: function outbound(label) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$hitCallback = _ref2.hitCallback,
        hitCallback = _ref2$hitCallback === void 0 ? function () {
          return null;
        } : _ref2$hitCallback;
      if (GoogleAnalytics.printToConsole()) {
        console.log('GoogleAnalytics.outbound', label);
      }
      if (_isEmpty(providerName)) {
        console.warn('Analytics provider is not set');
        return;
      }
      if (providerName === GOOGLE_UNIVERSAL_ANALYTICS_NAME) {
        ReactGUA.outboundLink({
          label: label
        }, hitCallback);
      }
      if (GoogleAnalytics.isGa4Configured()) {
        var options = {
          category: 'outbound',
          action: AnalyticsAction.CLICK,
          label: label
        };
        ReactGA4.gtag('event', FISHERMAN_EVENT, options);
      }
    }
  }, {
    key: "pageView",
    value: function pageView(path) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$title = _ref3.title,
        title = _ref3$title === void 0 ? '' : _ref3$title;
      if (GoogleAnalytics.printToConsole()) {
        console.log('GoogleAnalytics.pageView', path, title);
      }
      if (_isEmpty(providerName)) {
        console.warn('Analytics provider is not set');
        return;
      }
      if (providerName === GOOGLE_UNIVERSAL_ANALYTICS_NAME) {
        ReactGUA.pageview(path, undefined, title || undefined);
      }
      if (GoogleAnalytics.isGa4Configured()) {
        var payload = {
          hitType: 'pageview',
          page: path
        };
        if (!_isEmpty(title)) {
          payload = _objectSpread(_objectSpread({}, payload), {}, {
            page_title: title
          });
        }
        ReactGA4.send(payload);
      }
    }
  }]);
  return GoogleAnalytics;
}();
export { GoogleAnalytics as default };